module.exports = {
      id: "paper-plane-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0a12b861.svg#paper-plane-usage",
      toString: function () {
        return this.url;
      }
    }